<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <van-tabs v-model="hotelActive" animated :swipeable="false" title-active-color="#D7508D" @change="changeAction">
        <van-tab v-for="(hotelItem,hotelIndex) in hotelList" :key="hotelIndex" :title="hotelItem.storeName" >
          <div style="padding-bottom: 5rem">
            <div style="padding: 0">
              <!--banner-->
              <div class="content_container banner_br" >
                <van-swipe class="banner_br" style="height: 9.375rem" :autoplay="3000"  >
                  <van-swipe-item v-for="(imgUrlItem, index) in currentInfo.imgUrl" :key="index">
                    <van-image class="full_w" style="height: 9.375rem" fit="cover" :src="imgUrlItem"/>
                  </van-swipe-item>
                </van-swipe>
                <router-link v-if="hotelActive == hotelIndex" :to="{name:'parkImgList',query:{storeName:hotelItem.storeName,storeId:hotelItem.storeId}}"><p style="position: relative;background-color: #555555;margin-top: -2rem;margin-right: 1rem;padding: 0.1rem 0.3rem;" class="clear_style zt12 white ovh fr">图片{{currentInfo.imageNum}}张</p></router-link>
                <router-link v-if="hotelActive == hotelIndex" to="/parkImgList"><p style="position: relative;margin-top: -2rem;margin-left: 1rem;padding: 0.1rem 0.3rem;" class="clear_style zt14 white ovh fl">{{hotelItem.storeName}}</p></router-link>
              </div>
              <div style="padding: 0 1rem" class="clear_both">
                <p class="clear_both clear_style" style="border-bottom: 1px solid #eaeaea;padding: 0.7rem 0"><span class="fl zt14 black">{{currentInfo.address}}</span><router-link :to="{name:'storeMap',query:{storeName:hotelItem.storeName,storeId:hotelItem.storeId}}"><span class="fr zt14 black">地图/导航<img class="nav_item_btn fr" src="@/images/icon_arrow@3x.png"></span></router-link></p>
                <p class="clear_both clear_style" style="padding: 0.7rem 0"><router-link :to="{name:'hotelDec',query:{productStoreId:hotelItem.storeId}}"><span class="fl zt14 black">酒店介绍</span></router-link><img class="fr" style="width: 1.2rem;height: 1.2rem" @click="showShareSheet=true" src="@/images/share@3x.png"><router-link :to="{name:'hotelDec',query:{productStoreId:hotelItem.storeId}}"><span class="fr zt14 black" style="border-right: 1px solid #eaeaea;margin-right: 1rem">详情<img class="nav_item_btn fr" src="@/images/icon_arrow@3x.png"></span></router-link></p>
              </div>
              <div v-show="!(paramStartDate==''|| paramEndDate=='')" class="ovh" style="padding: 0.7rem 0;border-top: 1px solid #eaeaea;">
                <div style="padding: 0 1rem" class="ovh fl">
                  <div class="tc fl" @click="clickAction()">
                    <div class="grey zt12  date_item_w">{{getDayFromDate(paramStartDate)}}</div>
                    <div class="black zt14 date_item_w">{{startDate}}</div>
                  </div>
                  <div class="fl grey tc" style="margin: 0 5rem;width: 3rem;border-bottom: 1px solid #eaeaea">共{{nightNum}}晚</div>
                  <div class="tc fl" @click="clickAction()">
                    <div class="grey zt12 date_item_w" >{{getDayFromDate(paramEndDate)}}</div>
                    <div class="black zt14 date_item_w" >{{endDate}}</div>
                  </div>
                </div>
              </div>
            </div>

            <!--分界线-->
            <div class="base_line"></div>

            <van-loading style="margin-top: 2rem" v-show="showProductListLoading" size="24px" vertical>加载中...</van-loading>

            <div class="ovh">
              <div style="padding: 0.5rem;overflow-x: auto;overflow-y: hidden;height: 2rem;white-space: nowrap;">
                <van-button @click="touchCategoryAction(categoryItem)" v-for="(categoryItem, categoryIndex) in currentCatagoryList" :key="categoryIndex" plain hairline style="border-color: #E5E5E5!important;margin: 0 0.2rem" :class="categoryItem.isChecked == 'true'?'hotel_btn_select':''" :icon="categoryItem.isChecked == 'true'?'cross':''" round size="small">{{categoryItem.categoryName}}</van-button>
              </div>
            </div>
            <!--分界线-->
            <div v-if="currentNormalProductList.length && currentNormalProductList.length > 0" class="base_line"></div>
            <!--门票套餐-->
            <div class="cart_content">
              <div v-if="currentNormalProductList.length && currentNormalProductList.length > 0" v-for="(goodsItem, normalIndex) in currentNormalProductList" :key="normalIndex" class="content_item clear_both" style="padding: 0.7rem 0.5rem">
                <div class="fl clear_both" style="width: 7rem">
                  <router-link :to="{name:'hotelDetail',query:{productId:goodsItem.productId,storeId:hotelItem.storeId}}">
                    <van-image style="width: 6.8rem;height: 5.375rem" fit="cover" :src="goodsItem.imgUrl" />
                  </router-link>
                </div>
                <div class="fl" style="width: 12rem;padding: 0rem 0.5rem">
                  <p class="zt14 clear_style black blod">{{goodsItem.productName}}</p>
                  <p class="zt12 grey clear_style">{{goodsItem.productParam}}</p>
                </div>
                <div class="fl" style="position: absolute;margin: 4rem 0 0 7rem;padding-left: 0.5rem;width: 12.5rem">
                  <span class="zt14 themeColor fl blod">￥{{goodsItem.price}}</span>
                  <span v-if="goodsItem.status=='满房'" @click="addProductToCart(goodsItem.productId,hotelItem,goodsItem.status)" style="color:#9e9e9e;min-width: 3.75rem;height: 1.875rem;text-align: center" class="zt12 fr">{{goodsItem.status}}</span>
                  <van-button v-if="goodsItem.status!='满房'" @click="addProductToCart(goodsItem.productId,hotelItem,goodsItem.status)" plain hairline round color="#DB6299" size="small" type="primary" class="fr">{{goodsItem.status}}</van-button>
                </div>
              </div>
            </div>
            <!--分界线-->
            <div v-if="currentMealProductList.length && currentMealProductList.length > 0" class="base_line"></div>
            <!--门票套餐-->
            <div v-if="currentMealProductList.length && currentMealProductList.length > 0" class="cart_content">
              <p class="zt14 black blod">套餐推荐</p>
              <div v-for="(goodsItem, normalIndex) in currentMealProductList" class="content_item clear_both" style="padding: 0.7rem 0.5rem">
                <div class="fl clear_both" style="width: 7rem">
                  <router-link to="/hotelDetail">
                    <van-image style="width: 6.8rem;height: 5.375rem" fit="cover" :src="goodsItem.imgUrl" />
                  </router-link>
                </div>
                <div class="fl" style="width: 12rem;padding: 0rem 0.5rem">
                  <p class="zt14 clear_style black blod">{{goodsItem.productName}}</p>
                  <p class="zt12 grey clear_style">{{goodsItem.productParam}}</p>
                </div>
                <div class="fl" style="position: absolute;margin: 4rem 0 0 7rem;padding-left: 0.5rem;width: 12.5rem">
                  <span class="zt14 themeColor fl blod">￥{{goodsItem.price}}</span>
                  <span v-if="goodsItem.status=='满房'" @click="addProductToCart(goodsItem.productId,hotelItem,goodsItem.status)" style="color:#9e9e9e;min-width: 3.75rem;height: 1.875rem;text-align: center" class="zt12 fr">{{goodsItem.status}}</span>
                  <van-button v-if="goodsItem.status!='满房'" @click="addProductToCart(goodsItem.productId,hotelItem,goodsItem.status)" ref="taocan1" plain round color="#DB6299" loading-text="预订中..." size="small" type="primary" class="fr">{{goodsItem.status}}</van-button>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <!--日期选择上拉菜单-->
      <div ref="markView" class="goods-action-activity-shadow" @click="hideActivity()"></div>

      <!--预定须知-->
      <div ref="markView" class="goods-action-activity-shadow" @click="hideOrderTips()"></div>
      <div ref="couponsView" class="goods-action-activity-content animate_action">
        <div class="goods-action-activity-title full_w">
          <span class="zt14 black tc fl" style="margin-left: 1rem">预定须知</span>
        </div>
        <div style="background-color: white;padding: 0 0.5rem;width: 23rem;position: absolute;height: 28rem;overflow-y: scroll;" class="clear_both">
          <div class="cart_content">
            <div v-html="currentContent" class="content_item"></div>
          </div>
        </div>
      </div>

      <!--日期控件-->
      <van-calendar v-model="showCalendar" type="range" confirm-text="完成" confirm-disabled-text="请选择结束时间" :max-range="5" color="#D7508D" @confirm="onCalendarConfirm"/>
      <!--人数选择-->
      <van-popup v-model="showPerson" position="bottom" round>
        <p class="black zt14 tc">入住人数</p>
        <van-form input-align="right">
          <van-field name="roomNumber" label="房间">
            <template #input>
              <van-stepper v-model="roomNumber" />
            </template>
          </van-field>
          <van-field name="roomNumber" label="成人">
            <template #input>
              <van-stepper v-model="roomNumber" />
            </template>
          </van-field>
          <van-field name="roomNumber" label="儿童">
            <template #input>
              <van-stepper v-model="roomNumber" />
            </template>
          </van-field>
          <p class="tc"><van-button color="#D7508D" style="width: 17rem;height: 2.5rem;margin-top: 1rem" round type="primary" >保存</van-button></p>
        </van-form>
        <div class="ovh" style="height: 3rem"></div>
      </van-popup>

      <van-popup v-model="showShareSheet" round position="bottom" :style="{ height: '20%' }" >
        <div class="ovh" style="padding: 1.5rem 2rem">
          <div class="ovh fl tc" @click="shareFriend()" >
            <img style="width: 4rem" src="@/images/share_icon_1.png">
            <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">发送给朋友</p>
          </div>
          <div class="ovh fl tc" @click="onSelectAction()">
            <img style="width: 4rem" src="@/images/share_icon_2.png">
            <p class="zt14 tc clear_style" style="color: #939598;width: 9rem;line-height: 1rem">生成海报</p>
          </div>
          <div class="ovh fl tc" @click="showShareSheet=false">
            <img style="width: 4rem" src="@/images/share_icon_3.png">
            <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">取消分享</p>
          </div>
        </div>
      </van-popup>

      <van-overlay :show="showPopView" @click="showPopView = false" >
        <div class="ovh fr tr" style="margin-right: 4rem;margin-top: 1rem">
          <img class="fr" style="width: 2rem;margin-left: 1rem" src="@/images/share.png">
          <p class="zt16 fr white ovh tr">点击菜单分享给好友，立即赚取收益</p>
        </div>
      </van-overlay>

      <van-overlay :show="showImgView">
        <div v-show="!showShareLoading">
          <p v-if="showImgView" style="position: absolute;right: 0;margin: 0rem"><van-button @click="showImgView=false" color="#666" icon="close" type="default" size="small">关闭分享</van-button></p>
          <img class="full_w" :src="imgSrcUrl">
          <div v-if="showImgView" class="ovh zt16 tc white full_w" style="position: absolute;background-color: #EB84AB;height: 3rem;line-height: 3rem;margin-top: -3rem">. 长按保存图片 .</div>
        </div>
        <van-loading style="margin-top: 15rem" v-show="showShareLoading" size="24px" vertical>生成海报中...</van-loading>
      </van-overlay>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,loginInfo,severUrl,shareHotelUrl,wxUrl } from '@/router/Constant'
  import { clearCart,updateCartProduct,addProductToCart,login,deleteCartProduct,getDistributionDetail,getServerTime,getWeixinShare,boundTwoLevel,getShareInfo ,shareGetKcion} from '@/router/api';
  import { getHotelList,getHotelInfo,getHotelCategoryList,getHotelProductList } from '@/router/api'
  import { setStore,getStore,getCookie,setCookie ,setMiniProgramShare} from '@/utils/mUtil';
  import { Image as ImageView,Button,Swipe,SwipeItem,Dialog,Popup } from 'vant';
  import { Overlay,PullRefresh,Toast,Tab, Tabs,Calendar,Form,Field,Stepper,Loading } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';
  import datePicker from '@/components/page/common/Datepicker.vue';
  import shareMaskBg from '@/images/bg_share_mask.png'

  export default {
    name: 'hotelInfo',
    data() {
      return {
        token:"",
        hotelActive:0,
        productStoreTag:storeName,
        productStoreId:'',
        prodCatalogId:prodCatalogId,
        totalPrices:0,
        showLoading:true,
        showCoupons:false,
        showCalendar:false,
        showPerson:false,
        nextStepLoading:false,
        emptyCart:false,
        calendarDate:'',
        totalPrice:0,
        roomNumber:1,
        currentContent:"所以这里要放什么呢，暂时不知道",
        dateInfo:'',
        hotelList:[],
        currentInfo:[],
        currentCatagoryList:[],
        currentNormalProductList:[],
        currentMealProductList:[],
        nightNum:0,
        startDate:"",
        paramStartDate:"",
        endDate:"",
        paramEndDate:"",
        endDay:"",
        currentCatagoryStr:"",
        showShareSheet: false,
        showPopView:false,
        showImgView:false,
        shareActions: [{ name: '发送给朋友' }, { name: '生成海报' }],
        imgSrcUrl:'',
        showShareLoading:false,
        showProductListLoading:false,

      }
    },
    components: {
      [ImageView.name]: ImageView,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Dialog.name]: Dialog,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Calendar.name]:Calendar,
      [Popup.name]:Popup,
      [Form.name]:Form,
      [Field.name]:Field,
      [Stepper.name]:Stepper,
      [Loading.name]:Loading,
      footerView,
      loading,
      refresh,
      datePicker,
    },
    methods: {
      async initData() {
        this.getPartyId();
        this.getSeverTimeAction();
        this.clearCart();
        this.getHotelList();
        this.getDetail();
      },
      clearCart(){
        clearCart()
          .then(res => {
            console.log("clearCart");
            console.log(res);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {

            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      clickAction(){
        // debugger
        console.log(this.showCalendar)
        this.showCalendar=true
        console.log(this.showCalendar)
      },
      dateFormat (fmt, date) {
        let ret;
        let opt = {
          "y+": date.getFullYear().toString(),        // 年
          "M+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        // debugger
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret && ret[1].length) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },
      onCalendarConfirm(date){
        // debugger
        const [start, end] = date;
        this.showCalendar = false;
        this.calendarDate = this.dateFormat('MM月dd日',start) + '-' + this.dateFormat('MM月dd日',end);
        this.startDate = this.dateFormat('MM月dd日',start)
        this.endDate = this.dateFormat('MM月dd日',end)
        this.paramStartDate = this.dateFormat("yy-MM-dd", start)
        this.paramEndDate = this.dateFormat("yy-MM-dd", end)
        console.log(this.paramStartDate,this.paramEndDate)
        this.nightNum = (end - start)/(60*60*24*1000)
        this.getHotelProductListAction(this.hotelList[this.hotelActive])
      },

      // 获取当前的日期
      getSeverTimeAction () {
        getServerTime()
          .then(res => {
            console.log("getServerTime")
            console.log(res)
            if (res.ServerTime) {
              var nowDate = new Date(res.ServerTime)
              this.startDate = this.dateFormat("MM月dd日", nowDate)
              this.endDate = this.dateFormat("MM月dd日", new Date(nowDate.getTime() + (60*60*24*1000)))
              this.paramStartDate = this.dateFormat("yy-MM-dd", nowDate)
              this.paramEndDate = this.dateFormat("yy-MM-dd", new Date(nowDate.getTime() + (60*60*24*1000)))
              this.nightNum = 1
            } else {
              var date = new Date();
              this.startDate = this.dateFormat("MM月dd日", date)
              this.endDate = this.dateFormat("MM月dd日", new Date(date.getTime() + (60*60*24*1000)))
              this.paramStartDate = this.dateFormat("yy-MM-dd", nowDate)
              this.paramEndDate = this.dateFormat("yy-MM-dd", new Date(nowDate.getTime() + (60*60*24*1000)))
              this.nightNum = 1
            }
          })
          .catch(err => {
            console.log(err);
            var date = new Date();
            this.startDate = this.dateFormat("MM月dd日", date)
            this.endDate = this.dateFormat("MM月dd日", new Date(date.getTime() + (60*60*24*1000)))
            this.paramStartDate = this.dateFormat("yy-MM-dd", nowDate)
            this.paramEndDate = this.dateFormat("yy-MM-dd", new Date(nowDate.getTime() + (60*60*24*1000)))
            this.nightNum = 1
          });
        setTimeout(() => {
          this.isLoading = false
        }, 1000);
      },

      changeAction(name,title) {
        this.resetParam();
        this.getSeverTimeAction();
        this.getHotelInfo(this.hotelList[this.hotelActive])
        this.showProductListLoading = false
        this.showProductListLoading = true
        setTimeout(() => {
          this.getHotelProductListAction(this.hotelList[this.hotelActive])
        }, 1000);
      },

      resetParam(){
        this.clearCart();
        this.currentCatagoryList = [];
        this.currentNormalProductList = [];
        this.currentMealProductList = [];
        this.nightNum = 1;
        this.startDate = "";
        this.paramStartDate = "";
        this.endDate = "";
        this.paramEndDate = "";
        this.endDay = "";
        this.currentCatagoryStr = "";
      },

      // 获取酒店列表
      getHotelList() {
        getHotelList({externalLoginKey: getStore('externalLoginKey'),productStoreTag: this.productStoreTag})
          .then(res => {
            console.log("getHotelList");
            console.log(res);
            this.hotelList = res.hotelList
            this.getHotelInfo(this.hotelList[this.hotelActive])
            this.getHotelProductListAction(this.hotelList[this.hotelActive])
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              // Toast(res._ERROR_MESSAGE_);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 获取酒店详情
      getHotelInfo(productStoreItem) {
        getHotelInfo({externalLoginKey: getStore('externalLoginKey'),productStoreId: productStoreItem.storeId})
          .then(res => {
            console.log("getHotelInfo");
            console.log(res);
            this.currentInfo = res.storeInfo

            setMiniProgramShare('畅“住”杭州HelloKitty乐园 加入会员更有积分相送',this.currentInfo.imgUrl[0],wxUrl+encodeURIComponent(shareHotelUrl))
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              // Toast(res._ERROR_MESSAGE_);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 获取酒店产品列表
      getHotelProductListAction(productStoreItem){
        if (this.paramStartDate == '' || this.paramEndDate == '') {
          console.log("this.paramStartDate,this.paramEndDate")
          console.log(this.paramStartDate,this.paramEndDate)
          setTimeout(() => {
            this.getHotelProductListAction(this.hotelList[this.hotelActive])
          }, 1000);
        } else {
          var param = {externalLoginKey: getStore('externalLoginKey'),productStoreId: productStoreItem.storeId,prodCatalogId:productStoreItem.prodCatalogId,categoryId:this.currentCatagoryStr,startDate:this.paramStartDate,endDate:this.paramEndDate}
          console.log(param)
          getHotelProductList({externalLoginKey: getStore('externalLoginKey'),productStoreId: productStoreItem.storeId,prodCatalogId:productStoreItem.prodCatalogId,categoryId:this.currentCatagoryStr,startDate:this.paramStartDate,endDate:this.paramEndDate})
            .then(res => {
              console.log("getHotelProductList");
              console.log(res);
              this.currentCatagoryList = res.categroyList
              this.currentNormalProductList = res.normalList
              this.currentMealProductList = res.mealList
              console.log(this.currentCatagoryList, this.currentNormalProductList, this.currentMealProductList,"1")
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
              if (res._ERROR_MESSAGE_) {
                Toast(res._ERROR_MESSAGE_);
              } else {
                this.showProductListLoading = false
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      // 获取今天是周几
      getDayFromDate(dateStr){
        var date = new Date(dateStr)
        var a = new Array("日", "一", "二", "三", "四", "五", "六");
        var week = date.getDay();
        var str = "周"+ a[week];
        return str
      },
      touchCategoryAction(obj){
        if (obj.isChecked == 'false'){
          this.currentCatagoryStr += obj.catgoryId + ','
          this.getHotelProductListAction(this.hotelList[this.hotelActive])
        } else {
          var catgoryIdStr = obj.catgoryId + ','
          this.currentCatagoryStr = this.currentCatagoryStr.replace(catgoryIdStr,'')
          this.getHotelProductListAction(this.hotelList[this.hotelActive])
        }
      },
      addProductToCart(productId,hotelItem,status){
        if(status=='预定'){
          let param = {
            externalLoginKey:getStore('externalLoginKey'),
            quantity:1,
            reservStart:this.paramStartDate,
            reservLength:this.nightNum,
            reservPersons:1, //人数
            productId:productId,
            productStoreId:hotelItem.storeId,
            prodCatalogId:hotelItem.prodCatalogId,
          }
          console.log(param)
          addProductToCart({
            externalLoginKey:getStore('externalLoginKey'),
            quantity:1,
            reservStart:this.paramStartDate,
            reservLength:this.nightNum,
            reservPersons:1, //人数
            productId:productId,
            productStoreId:hotelItem.storeId,
            prodCatalogId:hotelItem.prodCatalogId,
          })
            .then(res => {
              console.log(res)
              if (res._ERROR_MESSAGE_) {
                Toast(res._ERROR_MESSAGE_);
              } else {
                console.log(res._EVENT_MESSAGE_);
                this.$router.push({name:'hotelComfirm',query:{productStoreId:hotelItem.storeId,prodCatalogId:hotelItem.prodCatalogId,storeName:hotelItem.storeName}})
              }
            })
            .catch(err => {
              console.log(err);
            });
        }else{
          Toast({message:'该商品当前不可预定'});
        }
      },
      // 购物车调整数量和规格详情
      updateCartProduct (type,cnt,catalogId,productId,shoppingListItemSeqId){
        if (type == "reduce") {
          if (cnt > 1) {
            cnt -= 1;
          } else {
            // Toast('已经减少到0了,删除购物车')
            this.deleteCartProduct(shoppingListItemSeqId)
            return false
          }
          productId = ""
        } else if(type == 'add') {
          cnt += 1;
          productId = ""
        }
        updateCartProduct({externalLoginKey:getStore('externalLoginKey'),prodCatalogId:catalogId,quantity:cnt,productId:productId,productStoreId:storeName,shoppingListItemSeqId:shoppingListItemSeqId})
          .then(res => {
            console.log("updateCartProduct")
            console.log(res)
            this.getStoreTicketList();
          })
          .catch(err => {
            console.log(err);
          });
      },
      updateCart(type,productId,num,shoppingListItemSeqId){
        if (getStore('islogIn') == 'false') {
          this.dialogAction('需要登录加入购物车，是否登录？')
        } else if (num == 0 && type == 'add') {
          this.addProductToCart(productId)
        } else {
          // 修改购物车
          this.updateCartProduct(type,num,prodCatalogId,productId,shoppingListItemSeqId)
        }
      },
      // 删除购物车里面的商品
      deleteCartProduct (shoppingListItemSeqId) {
        deleteCartProduct({externalLoginKey:getStore('externalLoginKey'),shoppingListItemSeqIdList:shoppingListItemSeqId,productStoreId:storeName,prodCatalogId:prodCatalogId})
          .then(res => {
            console.log("deleteCartProduct")
            console.log(res)
            this.getStoreTicketList();
          })
          .catch(err => {
            console.log(err);
          });
      },
      refreshData(res){
        this.tickets = res.tickets.tickets;
        this.yearCards = res.tickets.yearCards;
        this.Packages = res.tickets.Packages;
        this.totalPrice = res.tickets.totalPrice;
        if (this.totalPrice == 0) {
          this.emptyCart = true
        } else {
          this.emptyCart = false
        }
      },
      selectDateAction(){
        console.log(this.$refs.dataPicker.dateValue)
        this.dateInfo = this.$refs.dataPicker.dateValue
        this.clearCart();
        this.getStoreTicketList();
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to, from, next) => {
          window.scrollTo(0, 0)
        })
      },
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return y + '.' + MM + '.' + d
        }else{
          return ''
        }
      },
      dialogAction(msg){
        Dialog.confirm({
          message: msg
        }).then(() => {
          if (getStore('fromType')=='mini') {

          } else {
            if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
              wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
          }
        }).catch(() => {

        });
      },
      showOrderTips(desc){
        this.$refs.markView.style.bottom = '0px'
        this.$refs.markView.style.display = 'block'
        this.$refs.couponsView.style.bottom = '0px'
        this.currentContent = desc
      },
      hideOrderTips() {
        this.$refs.markView.style.bottom = -window.innerHeight + 'px'
        this.$refs.couponsView.style.bottom = -window.innerHeight + 'px'
      },
      pushConfimView(){
        this.nextStepLoading = true;
        setTimeout(() => {
          this.nextStepLoading = false;
          this.$router.push({name:'ticketComfirm',params:{selectedDate:this.dateInfo}})
        }, 1000);
      },
      dateFormat (fmt, date) {
        let ret;
        let opt = {
          "y+": date.getFullYear().toString(),        // 年
          "M+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret && ret[1].length) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },
      //获取当前分销人信息
      getDetail:function(){
        let param = {
          externalLoginKey: getStore('externalLoginKey')
        }
        getDistributionDetail(param)
          .then(res => {
            console.log('getDistributionDetail');
            console.log(res);
            if(!res._ERROR_MESSAGE_){
              //成功
              this.distributionInfo = res.resultMap
            }else{
              Toast({message:res._ERROR_MESSAGE_})
            }
            this.getConfig()
          })
          .catch(err => {
            this.getConfig()
            console.log(err);
          });
      },


      //转发给朋友
      shareFriend:function(){
        this.showShareSheet=false
        this.showPopView = true
        this.shareGetKcion()
      },

      //文章转发获得K币
      shareGetKcion:function(){
        shareGetKcion({externalLoginKey:getStore('externalLoginKey')})
          .then(res => {
            console.log('转发成功')
            console.log(res)
          })
          .catch(err => {
            console.log(err);
          });
      },


      //获取当前分享的内容
      getConfig:function(){
        let param;
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          //这个是安卓操作系统
          param = 'android'
        }
        if (isIOS) {
          //这个是ios操作系统
          param = 'ios'
        }
        let paramList = {
          url: window.location.href,
          os:param
        }
        getWeixinShare(paramList).then(res => {
          console.log('getWeixinShare');
          console.log(res)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.shareMap.appId, // 必填，公众号的唯一标识
            timestamp: res.shareMap.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.shareMap.nonceStr, // 必填，生成签名的随机串
            signature: res.shareMap.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          });

          var thisBlock = this
          wx.ready(function(){
            wx.updateAppMessageShareData({
              title: '畅“住”杭州HelloKitty乐园 加入会员更有积分相送', // 分享标题
              desc: "城堡酒店预定", // 分享描述
              link: severUrl+'/hotel/shareHotel.html' +'?/hotelInfo?partyId='+thisBlock.distributionInfo.partyId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: thisBlock.currentInfo.imgUrl[0], // 分享图标
              success: function () {
                console.log("url=======" + severUrl+'/hotel/shareHotel.html' +'?/hotelInfo?partyId='+thisBlock.distributionInfo.partyId,)
              },error:function () {
              }
            })

            //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: '畅“住”杭州HelloKitty乐园 加入会员更有积分相送',
              desc: "城堡酒店预定",
              link: severUrl+'/hotel/shareHotel.html' +'?/hotelInfo?partyId='+thisBlock.distributionInfo.partyId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: thisBlock.currentInfo.imgUrl[0],
              success: function () {
              },error:function () {
              }
            })
          });

        })
      },

      //绑定分销人的信息
      getPartyId:function() {

        if(window.location.href.indexOf('partyId')!=-1){
          if(getStore('islogIn') != 'true'){
            console.log("当前用户未登录")
          }else{
            console.log("当前用户已登录")
            // 获得参数
            var currentUrl = window.location.href;
            var allParamArr = currentUrl.split("&");
            var partyId = "";
            for (var i = 0; i < allParamArr.length; i++) {
              if (allParamArr[i].indexOf("partyId") == 0) {
                partyId = allParamArr[i].split("=")[1];
                break;
              }
            }

            boundTwoLevel({partyId:partyId,externalLoginKey:getStore('externalLoginKey')})
              .then(res => {
                console.log(res)
                if(!res._ERROR_MESSAGE_){
                  console.log('绑定成功')
                }else{
                  Toast({message:res._ERROR_MESSAGE_})
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        }else{
          console.log('未获取到partyId')
        }
      },

      onSelectAction() {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.showShareSheet = false;
        console.log("生成海报中")
        this.showImgView = true
        this.showShareLoading = true
        this.getShareInfo();
      },

      onCancel(){
        this.showShareSheet = false;
      },

      getShareInfo() {
        var qrCodeContent = severUrl+'/hotel/shareHotel.html' +'?/hotelInfo?partyId='+this.distributionInfo.partyId
        console.log({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: this.hotelList[this.hotelActive].storeId})
        getShareInfo({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: this.hotelList[this.hotelActive].storeId})
          .then(res => {
            console.log("getShareInfo")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast.fail(res._ERROR_MESSAGE_);
            } else {
              console.log(res._EVENT_MESSAGE_)

              // 当店铺是酒店的时候，酒店的店铺需要的参数为二维码图片和头部的图片和分享图片
              if (this.hotelList[this.hotelActive].storeId.indexOf('Hotel') != -1) {
                if (res.qrImg != '' && res.headImg != ''&& res.storeImg!='' && res.qrImg != undefined && res.headImg != undefined&& res.storeImg!=undefined) {
                  setTimeout(() => {
                    this.doMyCanvas(res.qrImg,res.headImg,res.storeImg)
                  }, 1000);
                } else {
                  Toast.fail("请联系管理员完成分享配置")
                  this.showShareLoading = false
                  this.showImgView = false
                }
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      doMyCanvas(imgQr,headImg,storeImg) {
        console.log(window.screen.width,window.screen.height)
        var param = {
          width: window.outerWidth * 2, // 卡牌宽度
          height: window.outerHeight * 2, // 卡
          imgBGMask:shareMaskBg,
          imgBG: storeImg, //背景
          imgHead:headImg,
          imgQr: imgQr, // 卡牌底部二维码
        };

        console.log(param)

        // var c= document.getElementById('canvas');
        var c = document.createElement('canvas');
        var ctx = c.getContext("2d");

        c.width = param.width;
        c.height = param.height;
        var img = new Image();
        img.crossOrigin = 'Anonymous'
        img.src = param.imgBG;
        img.onload = () => {

          // 设置背景为白色
          var imageData = ctx.getImageData(0, 0, c.width, c.height);
          for(var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的,则设置成白色
            if(imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          ctx.putImageData(imageData, 0, 0);


          var bGH = 945
          var startX = 50 + (param.width - 750)/2
          console.log("param.height" + param.height)
          console.log("startY======" + startY)
          var startY = (param.height - bGH - 250) / 2  // 最小的内容区域为1100px

          // 设置背景图
          var goodsImgWidth = param.width * 2
          var goodsImgHeight = param.height * 2
          var oData,newSrc;
          ctx.drawImage(img, -(goodsImgWidth-param.width)/2, -(goodsImgHeight-param.width)/2/2 + startY/2, goodsImgWidth, goodsImgHeight);
          oData = ctx.getImageData(0,0,param.width,param.height);
          newSrc = this.gaussBlur(oData);
          ctx.putImageData(newSrc, 0, 0);

          // 设置蒙版遮罩
          var maskImgW = param.width
          var maskImgH = param.height
          var maskImg = new Image()
          maskImg.crossOrigin = 'Anonymous'
          maskImg.src = param.imgBGMask
          maskImg.onload = () => {

            ctx.drawImage(maskImg, 0, 0, maskImgW, maskImgH);

            // 画圆角矩形
            this.fillRoundRect(ctx,startX,startY,param.width - (startX * 2),bGH,20)

            startX += 30
            startY += 40
            // 设置商品头图
            var headImg = new Image();
            headImg.crossOrigin = 'Anonymous'
            headImg.src = param.imgHead
            headImg.onload = () => {
              console.log(startX,startY,param.width - startX*2, 100)
              ctx.drawImage(headImg, startX,startY,param.width - startX*2, 100);
              // 设置商品主图
              startY += 100 + 30
              var goodsImg = new Image();
              goodsImg.crossOrigin = 'Anonymous'
              goodsImg.src = param.imgBG
              goodsImg.onload = () => {
                ctx.drawImage(goodsImg, startX, startY, param.width - startX*2, param.width - startX*2);

                // 设置商品名称
                startY += (param.width - startX*2 + 60)
                ctx.font = 'normal 32px Microsoft YaHei';
                ctx.textAlign = 'left';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#6d6e70';
                ctx.fillText(this.hotelList[this.hotelActive].storeName, startX, startY);

                // 设置商品价格
                startY += 50
                ctx.font = 'normal 32px Microsoft YaHei';
                ctx.textAlign = 'left';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#EB84AB';
                ctx.fillText("畅“住”HelloKittyPark", startX, startY);

                // 设置分享人名称
                ctx.font = 'normal 32px Microsoft YaHei';
                ctx.textAlign = 'right';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#6d6e70';
                ctx.fillText(this.distributionInfo.name, param.width - startX, startY);

                // 设置提示
                startY += 50
                ctx.font = 'normal 28px Microsoft YaHei';
                ctx.textAlign = 'right';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#b2b3b6';
                ctx.fillText('"分享给你我的快乐！"', param.width - startX, startY);

                // 画二维码圆角矩形
                var qrw = 150
                startY += 40
                startX += (param.width - startX * 2 - qrw)/2
                this.fillRoundRect(ctx,startX,startY,qrw,qrw,20)

                // 设置二维码图
                startY += 5
                startX += 5
                var qrImg = new Image();
                qrImg.crossOrigin = 'Anonymous'
                qrImg.src = param.imgQr
                qrImg.onload = () => {
                  ctx.drawImage(qrImg, startX, startY, qrw-10, qrw-10);

                  // 设置长按二维码提示
                  startY += qrw + 50
                  startX = param.width / 2
                  ctx.font = 'normal 28px Microsoft YaHei';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';
                  ctx.fillStyle = '#fff';
                  ctx.fillText("长按识别二维码 发现更多精彩", startX, startY);

                  var imgUrl = c.toDataURL('image/jpeg', 2.0);
                  console.log(imgUrl)
                  this.showShareLoading = false
                  this.imgSrcUrl = imgUrl
                }
              }
            }
          };
        };
      },

      fillRoundRect(cxt, x, y, width, height, radius) {
        //圆的直径必然要小于矩形的宽高
        if (2 * radius > width || 2 * radius > height) { return false; }

        cxt.save();
        cxt.translate(x, y);
        //绘制圆角矩形的各个边
        this.drawRoundRectPath(cxt, width, height, radius);
        cxt.fillStyle = "white"; //若是给定了值就用给定的值否则给予默认值
        cxt.fill();
        cxt.restore();
      },

      drawRoundRectPath(cxt, width, height,radius) {
        var  r0 = radius,r1 = radius,r2 = radius,r3 = radius;
        cxt.beginPath(0);
        //从右下角顺时针绘制，弧度从0到1/2PI
        cxt.arc(width - r0, height - r0, r0, 0, Math.PI / 2);

        //矩形下边线
        cxt.lineTo(r1, height);

        //左下角圆弧，弧度从1/2PI到PI
        cxt.arc(r1, height - r1, r1, Math.PI / 2, Math.PI);

        //矩形左边线
        cxt.lineTo(0, r2);

        //左上角圆弧，弧度从PI到3/2PI
        cxt.arc(r2, r2, r2, Math.PI, Math.PI * 3 / 2);

        //上边线
        cxt.lineTo(width - r3, 0);

        //右上角圆弧
        cxt.arc(width - r3, r3, r3, Math.PI * 3 / 2, Math.PI * 2);

        //右边线
        cxt.lineTo(width, height - r3);
        cxt.closePath();
      },

      gaussBlur(imgData) {
        var pixes = imgData.data;
        var width = imgData.width;
        var height = imgData.height;
        var gaussMatrix = [],
          gaussSum = 0,
          x, y,
          r, g, b, a,
          i, j, k, len;

        var radius = 50;
        var sigma = 10;

        a = 1 / (Math.sqrt(2 * Math.PI) * sigma);
        b = -1 / (2 * sigma * sigma);
        //生成高斯矩阵
        for (i = 0, x = -radius; x <= radius; x++, i++){
          g = a * Math.exp(b * x * x);
          gaussMatrix[i] = g;
          gaussSum += g;

        }
        //归一化, 保证高斯矩阵的值在[0,1]之间
        for (i = 0, len = gaussMatrix.length; i < len; i++) {
          gaussMatrix[i] /= gaussSum;
        }
        //x 方向一维高斯运算
        for (y = 0; y < height; y++) {
          for (x = 0; x < width; x++) {
            r = g = b = a = 0;
            gaussSum = 0;
            for(j = -radius; j <= radius; j++){
              k = x + j;
              if(k >= 0 && k < width){//确保 k 没超出 x 的范围
                //r,g,b,a 四个一组
                i = (y * width + k) * 4;
                r += pixes[i] * gaussMatrix[j + radius];
                g += pixes[i + 1] * gaussMatrix[j + radius];
                b += pixes[i + 2] * gaussMatrix[j + radius];
                // a += pixes[i + 3] * gaussMatrix[j];
                gaussSum += gaussMatrix[j + radius];
              }
            }
            i = (y * width + x) * 4;
            // 除以 gaussSum 是为了消除处于边缘的像素, 高斯运算不足的问题
            // console.log(gaussSum)
            pixes[i] = r / gaussSum;
            pixes[i + 1] = g / gaussSum;
            pixes[i + 2] = b / gaussSum;
            // pixes[i + 3] = a ;
          }
        }
        //y 方向一维高斯运算
        for (x = 0; x < width; x++) {
          for (y = 0; y < height; y++) {
            r = g = b = a = 0;
            gaussSum = 0;
            for(j = -radius; j <= radius; j++){
              k = y + j;
              if(k >= 0 && k < height){//确保 k 没超出 y 的范围
                i = (k * width + x) * 4;
                r += pixes[i] * gaussMatrix[j + radius];
                g += pixes[i + 1] * gaussMatrix[j + radius];
                b += pixes[i + 2] * gaussMatrix[j + radius];
                // a += pixes[i + 3] * gaussMatrix[j];
                gaussSum += gaussMatrix[j + radius];
              }
            }
            i = (y * width + x) * 4;
            pixes[i] = r / gaussSum;
            pixes[i + 1] = g / gaussSum;
            pixes[i + 2] = b / gaussSum;
          }
        }
        //end
        return imgData;
      }

    },
    mounted() {
      this.initData();
      this.resetScorllView();
    },

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 0.6rem;
    background-color: #f4f4f4;
  }

  .content_item {
    background-color: white;padding: 0.3rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 18rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  /*商品活动/优惠券*/
  .goods-action-activity-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: none;
    z-index: 99;
  }
  .goods-action-activity-content{
    width:100%;
    height:30.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    padding-bottom: 1rem;
    z-index: 99;
  }
  .goods-action-activity-title{
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size:1rem;
    color:#333312;
  }
  .goods-action-activity-content-bottom{
    width:21.4375rem;
    margin:0 auto;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-activity-content-name{
    font-size:1rem;
    color:#333312;
    height: 3rem;
    line-height: 3rem;
  }
  .goods-action-activity-content-list{
    width:100%;
  }
  .goods-action-activity-content-each{
    width:100%;
    height: 6.875rem;
    margin-bottom: 0.3125rem;
  }
  .goods-action-activity-content-each img{
    width:100%;
    height: 100%;
  }
  .goods-action-activity-content-list-left{
    display: inline-block;
    vertical-align: top;
    width:2rem;
  }
  .goods-action-activity-content-list-left img{
    width:1.25rem;
    height:0.90625rem;
  }
  .goods-action-activity-content-list-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.5rem);
  }
  .goods-action-activity-content-each-left{
    display: inline-block;
    vertical-align: top;
    width:5rem;
    position: relative;
    top: -5rem;
    left: 2.4rem;
  }
  .goods-action-activity-price{
    color:white;
    font-size: 1.71875rem;
  }
  .goods-action-activity-content-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 5rem);
    position:relative;
    top: -8rem;
    left: 8rem;
  }
  .goods-action-activity-content-desc{
    color:#EB84AB;
    font-size:0.9375rem;
    margin-bottom: 0.6875rem;
  }
  .goods-action-activity-content-time{
    color:#666;
    font-size:0.625rem;
    margin-bottom: 0.96875rem;
  }
  .goods-action-activity-content-status{
    width:100%;
    height: 1.40625rem;
  }
  .goods-action-activity-content-status-desc{
    color:#999;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width: 7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    height: 1.40625rem;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button{
    width:4.6875rem;
    height: 1.40625rem;
    display: inline-block;
    vertical-align: top;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button button{
    width:100%;
    font-size: 0.75rem;
    color:#EB84AB;
    text-align: center;
    line-height: 1.40625rem;
    border-radius:0.703125rem;
    border:1px solid #EB84AB;
  }
  .goods-action-activity-desc{
    color:#EB84AB;
    font-size:1rem;
  }
  .goods-action-activity-time{
    font-size:0.875rem;
    color:#999;
    line-height: 2rem;
  }

  .coupon_item {
    height: 7rem;
  }

  .span_type_item {
    border: 1px solid #E5E5E5;padding: 0.2rem 0.7rem;margin: 0 0.5rem 0 0;border-radius: 0.7rem;
  }

  .span_type_item_active {
    border: 1px solid #D7508D;color: #D7508D;
  }

  .date_item_w{
    width: 4rem;
  }

  div::-webkit-scrollbar {
    display: none;
  }

  .hotel_btn_select {
    background-color: #D7508D;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/hotel/hotelInfo.vue